<template>
  <div class="mt-2" v-b-tooltip.hover.right :title="item.id ? '' : 'Please save this task, before adding a checklist'">
    <button :disabled="!item.id" class="btn btn-block btn-info" id="createChecklist">
      <i class="far fa-clone icon-left"></i>
      Checklist
    </button>

    <b-popover target="createChecklist" ref="createChecklist" triggers="click blur">
      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Add checklist</div>

      <div class="label mt-1 mb-1">Title</div>
      <input type="text" class="form-control" v-model="newChecklistTitle" />

      <button :disabled="!newChecklistTitle" class="mt-2 btn btn-block btn-success" @click="addChecklist(newChecklistTitle)">Add</button>
    </b-popover>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { ChecklistModule, ChecklistStore } from '@/store/checklist';
  import { IBoardItemDto } from '@/apiclient/apiclient_generated';
  import { Prop } from 'vue-property-decorator';

  @Component({})
  export default class AddChecklist extends Vue {
    private checklistStore: ChecklistModule = ChecklistStore;
    private newChecklistTitle = 'Subtasks';

    @Prop() item: IBoardItemDto;

    async addChecklist(title) {
      const boardItemId = this.item.id;
      const data = {
        title,
        boardItemId,
      };
      await this.checklistStore.addChecklist(data);
      this.newChecklistTitle = 'Subtasks';
      const popover: any = this.$refs.createChecklist;
      if (popover) {
        popover.doClose();
      }
    }
  }
</script>

<style scoped lang="scss"></style>
